// India-first formatting helpers (₹ INR, Indian digit grouping)

export const formatINR = (n, opts = {}) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  const { decimals = 2 } = opts;
  return "\u20b9" + Number(n).toLocaleString("en-IN", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};

export const formatNum = (n, decimals = 2) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return Number(n).toLocaleString("en-IN", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};

export const formatPercent = (n, decimals = 2) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  const sign = n > 0 ? "+" : "";
  return `${sign}${Number(n).toFixed(decimals)}%`;
};

export const signColor = (n) => {
  if (n > 0) return "text-emerald-400";
  if (n < 0) return "text-rose-400";
  return "text-zinc-400";
};

export const signBg = (n) => {
  if (n > 0) return "bg-emerald-500/10 border-emerald-500/25 text-emerald-400";
  if (n < 0) return "bg-rose-500/10 border-rose-500/25 text-rose-400";
  return "bg-zinc-500/10 border-zinc-500/25 text-zinc-400";
};

const healthMap = {
  "Healthy": "bg-emerald-500/10 text-emerald-400 border-emerald-500/25",
  "Improving": "bg-emerald-500/10 text-emerald-400 border-emerald-500/25",
  "Moderate": "bg-amber-500/10 text-amber-400 border-amber-500/25",
  "Elevated Risk": "bg-rose-500/10 text-rose-400 border-rose-500/25",
};
export const healthClass = (status) => healthMap[status] || "bg-zinc-500/10 text-zinc-400 border-zinc-500/25";

const levelMap = {
  "Low": "bg-emerald-500/10 text-emerald-400 border-emerald-500/25",
  "Moderate": "bg-amber-500/10 text-amber-400 border-amber-500/25",
  "Elevated": "bg-orange-500/10 text-orange-400 border-orange-500/25",
  "Severe": "bg-rose-500/10 text-rose-400 border-rose-500/25",
};
export const riskLevelClass = (level) => levelMap[level] || "bg-zinc-500/10 text-zinc-400 border-zinc-500/25";
